// @greenlight-spec: 19-design-system.md
import * as React from 'react';

import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

/**
 * The canonical stacked-list card (mobile lists, queues). One source of truth for
 * elevation/border/radius so Integrations and Permissions cards never drift.
 * Extra props (className, data-testid, …) pass through to the Card.
 */
export function ListCard({
  className,
  children,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>): React.JSX.Element {
  return (
    <Card className={cn('border-border/60 shadow-sm', className)} {...rest}>
      <CardContent className="p-4">{children}</CardContent>
    </Card>
  );
}
